export const EVENT_SOURCE_COMPONENT_COOKIE_NAME = 'event_source_component'
